// extracted by mini-css-extract-plugin
export default {"base":"TableRow_base__WDGYu","regular":"TableRow_regular__fdgMi TableRow_base__WDGYu","fout":"TableRow_fout__T7YD8 TableRow_base__WDGYu"};